import { getFragmentData } from "@/__generated__";
import type {
  VisitByClientWithTokenQuery,
  VisitByClientWithTokenQueryVariables,
} from "@/__generated__/graphql";
import {
  VisitByClientWithTokenDocument,
  VisitClientFragmentFragmentDoc,
} from "@/__generated__/graphql";
import { mapToVisitDetailData } from "@/components/shared/visits/visit-detail";
import { useQuery, type QueryHookOptions } from "@apollo/client";

export const useVisitByClientWithTokenQuery = (
  options?: QueryHookOptions<VisitByClientWithTokenQuery, VisitByClientWithTokenQueryVariables>,
) => {
  const result = useQuery(VisitByClientWithTokenDocument, options);

  const token = options?.variables?.token ?? null;
  const visitDetailData = result.data?.visitByClientWithToken
    ? mapToVisitDetailData(
        getFragmentData(VisitClientFragmentFragmentDoc, result.data.visitByClientWithToken),
        token,
      )
    : null;

  return {
    ...result,
    data: visitDetailData,
  };
};
